var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3026 1.33203H11.6979C11.4967 1.33203 11.3336 1.4923 11.3336 1.69001V14.3074C11.3336 14.505 11.4967 14.6654 11.6979 14.6654H14.3026C14.5038 14.6654 14.6669 14.505 14.6669 14.3074V1.69001C14.6669 1.4923 14.5039 1.33203 14.3026 1.33203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63601 7.9987H1.03131C0.830096 7.9987 0.666992 8.15915 0.666992 8.35708V14.307C0.666992 14.5049 0.830096 14.6654 1.03131 14.6654H3.63601C3.83722 14.6654 4.00033 14.5049 4.00033 14.307V8.35708C4.00033 8.15918 3.83722 7.9987 3.63601 7.9987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36464 4.66536H8.96934C9.17059 4.66536 9.33366 4.83943 9.33366 5.05416V14.2766C9.33366 14.4912 9.17056 14.6654 8.96934 14.6654H6.36464C6.16343 14.6654 6.00033 14.4912 6.00033 14.2766V5.05416C6.00033 4.83943 6.16343 4.66536 6.36464 4.66536Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignal);
export default __webpack_public_path__ + "static/media/icon-signal.e0c0303625a8d6055cb69021476e0baa.svg";
export { ForwardRef as ReactComponent };